import type { QuillDelta } from '@/components/custom/quill-editor';
import { BASE_URL } from '@/config/constants';

const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'avif', 'svg'];

/**
 * Parse Quill Delta JSON format, return Delta object
 */
export const parseRichTextValue = (value: unknown): QuillDelta => {
  if (!value) return { ops: [{ insert: '' }] };
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (parsed.ops && Array.isArray(parsed.ops)) {
        return parsed as QuillDelta;
      }
    } catch {
      // Not valid JSON, return empty Delta
    }
  }
  if (typeof value === 'object' && value !== null) {
    const delta = value as any;
    if (delta.ops && Array.isArray(delta.ops)) {
      return delta as QuillDelta;
    }
  }
  return { ops: [{ insert: '' }] };
};

export const parseArrayValue = (value: unknown): Record<string, unknown>[] => {
  if (Array.isArray(value)) {
    return value.filter(
      (item): item is Record<string, unknown> => typeof item === 'object' && item !== null && !Array.isArray(item)
    );
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.filter(
          (item): item is Record<string, unknown> => typeof item === 'object' && item !== null && !Array.isArray(item)
        );
      }
    } catch {
      return [];
    }
  }

  return [];
};

export const isEmptyValue = (value: unknown) => value === null || value === undefined || value === '';

export const isImageAsset = (filepath: string) => {
  const extension = filepath.split('.').pop()?.toLowerCase() || '';
  return imageExtensions.includes(extension);
};

export const getAssetUrl = (tenantSlug: string, assetId: number) => {
  return `${BASE_URL}/tenants/${tenantSlug}/assets/${assetId}/content`;
};
